import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

import { DevOnly } from 'src/app/components/Elements/DevOnly';
import { StyledLink } from 'src/landing-pages/capsule-elements/Link/styles';

export const Notice = styled(Typography).attrs({ as: 'p', variant: 'body' })`
  margin: 0 !important;

  & > * {
    margin: 0 !important;
  }
`;

const StyledDevOnly = styled(DevOnly)`
  margin-top: ${props => props.theme.space.s6} !important;
`;

export const DevOnlyRegistrationInfo = () => (
  <StyledDevOnly>
    <Notice>
      If you’re curious about rules around MFA or how Tonic can potentially affect a registration you create, please{' '}
      <StyledLink
        href="https://capsulerx.atlassian.net/wiki/spaces/CA/pages/3197632522/Registering+Accounts+with+Tonic+MFA+in+mind"
        target="_blank"
        rel="noopener noreferrer"
      >
        see this Confluence article
      </StyledLink>
      .
    </Notice>
  </StyledDevOnly>
);
